import apiService from "service/api";
import { IUserPayload } from "types/hf/staff";

export const getAllStaff = async (hfId: number, page: any, size: number) => {
  let url = `/healthfacilities/staff/${hfId}/?page=${page}&size=${size}`;

  const method = "get";
  return apiService(url, method, null, true, {});
};

export const createStaff = async (
  hfId: number,
  user_id: string,
  branch?: string
) => {
  const url = `/healthfacilities/${hfId}/branch/add-personnel/`;

  return apiService(url, "POST", { user_id, branch }, true);
};

export const deleteStaff = async (hfId: number, staffId: number) => {
  const url = `/healthfacilities/staff/${hfId}/${staffId}`;

  return apiService(url, "DELETE", null, true);
};
